<template>
  <section v-if="assetContainer">
    <key-value label="Notes">
      <template #value>
        <div class="d-flex flex-row align-center justify-between asset-container-notes">
          <span v-html="assetContainer.notes ?? '--'"></span>
          <v-spacer />
          <v-btn
            :title="t('yard.tooltips.editNotes')"
            variant="plain"
            icon="mdi-pencil"
            size="small"
            class="edit-button"
            @click="isNotesDialogVisible = true" />
        </div>
      </template>
    </key-value>

    <yard-view-asset-container-notes-dialog
      :is-visible="isNotesDialogVisible"
      :asset-container="assetContainer"
      @close="isNotesDialogVisible = false" />
  </section>
</template>

<script>
import { defineComponent, ref } from 'vue';
import YardViewAssetContainerNotesDialog from '@/modules/yard/components/AssetContainer/YardViewAssetContainerNotesDialog.vue';
import KeyValue from '@satellite/components/elements/key_value/KeyValue.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewAssetContainerNotes',
  components: {
    YardViewAssetContainerNotesDialog,
    KeyValue
  },
  props: {
    assetContainer: {
      type: Object,
      required: true
    }
  },
  setup() {
    const { t } = useI18n();
    const isNotesDialogVisible = ref(false);

    return {
      t,
      isNotesDialogVisible
    };
  }
});
</script>
<style lang="scss">
.asset-container-notes {
  &:hover {
    .edit-button {
      opacity: 1;
    }
  }

  .edit-button {
    opacity: 0;
    padding: 0;
    background-color: $white;
    margin-left: 4px;
    transition: opacity 0.3s ease-in-out;
  }
}
</style>
